import { capture } from "./capture";

export const TeammatesTracking = {
  /** Access requested for a teammate. */
  accessRequested: (teammateKey: string) => {
    capture("teammates.access_requested", { teammate_key: teammateKey });
  },

  /** Teammate detail page viewed. */
  detailViewed: (teammateKey: string) => {
    capture("teammates.detail_viewed", { teammate_key: teammateKey });
  },
};
